/**
 * all states from store
 */
export default {};
